import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { HomePageTwoComponent } from './components/pages/home-page-two/home-page-two.component';
import { AboutComponent } from './components/pages/about/about.component';
import { PricingComponent } from './components/pages/pricing/pricing.component';
import { FaqComponent } from './components/pages/faq/faq.component';
import { DesignerComponent } from './components/pages/designer/designer.component';
import { TestimonialsComponent } from './components/pages/testimonials/testimonials.component';
import { ErrorComponent } from './components/pages/error/error.component';
import { SignInComponent } from './components/pages/sign-in/sign-in.component';
import { SignUpComponent } from './components/pages/sign-up/sign-up.component';
import { RecoverPasswordComponent } from './components/pages/recover-password/recover-password.component';
import { TermsConditionsComponent } from './components/pages/terms-conditions/terms-conditions.component';
import { PrivacyPolicyComponent } from './components/pages/privacy-policy/privacy-policy.component';
import { ComingSoonComponent } from './components/pages/coming-soon/coming-soon.component';
import { ServicesComponent } from './components/pages/services/services.component';
import { ServicesDetailsComponent } from './components/pages/services-details/services-details.component';
import { ProductsComponent } from './components/pages/products/products.component';
import { CartComponent } from './components/pages/cart/cart.component';
import { CheckoutComponent } from './components/pages/checkout/checkout.component';
import { ProductsDetailsComponent } from './components/pages/products-details/products-details.component';
import { BlogComponent } from './components/pages/blog/blog.component';
import { BlogDetailsComponent } from './components/pages/blog-details/blog-details.component';
import { ContactComponent } from './components/pages/contact/contact.component';
import { OrderOnlineComponent } from './components/pages/order-online/order-online.component';
import { OrderAppsComponent } from './components/pages/order-apps/order-apps.component';
import { MenuComponent } from './components/pages/menu/menu.component';
import { OrderSuccessComponent } from './components/pages/order-success/order-success.component';
import { AccountComponent } from './components/pages/account/account.component';
import { OrderDetailsComponent } from './components/pages/order-details/order-details.component';
import { WishlistComponent } from './components/pages/wishlist/wishlist.component';
import { AuthGuard } from './components/common/Auth/auth.guard';
import { OffersComponent } from './components/pages/offers/offers.component';
import { CustomFoodComponent } from './components/pages/custom-food/custom-food.component';
import { FailedOrderComponent } from './components/pages/failed-order/failed-order.component';

const routes: Routes = [
    {path: '', component: HomePageTwoComponent},  // done with api
    {path: 'about', component: AboutComponent}, //
    {path: 'mainMenu', component: MenuComponent}, // done with api
    {path: 'menu/maincategory/:catId/:catName', component: MenuComponent}, // done with api
    {path: 'menu/subcategory/:subCatId/:subCatName', component: MenuComponent}, // done with api
    // {path: 'order-online', component: OrderOnlineComponent}, //
    {path: 'order-apps', component: OrderAppsComponent}, //
    {path: 'order-success/:id', component: OrderSuccessComponent}, // 
    {path: 'error', component: ErrorComponent}, // done with api
    {path: 'cart', component: CartComponent}, // 
    {path: 'checkout', component: CheckoutComponent}, // 
    {path: 'account', component: AccountComponent, canActivate: [AuthGuard]}, //done with api
    {path: 'order-details/:id', component: OrderDetailsComponent},  //done with api
    {path: 'wishlist', component: WishlistComponent}, // done with api

    {path: 'reset-password', component: RecoverPasswordComponent}, // done with api
    {path: 'terms-condition', component: TermsConditionsComponent}, // 
    {path: 'privacy-policy', component: PrivacyPolicyComponent}, // 
    {path: 'offers', component: OffersComponent}, // 
    { path: 'custom-food', component: CustomFoodComponent }, //
    // {path: 'pricing', component: PricingComponent},
    // {path: 'faq', component: FaqComponent},
    // {path: 'designer', component: DesignerComponent},
    // {path: 'testimonials', component: TestimonialsComponent},
    {path: 'sign-in', component: SignInComponent, canActivate: [AuthGuard]},
    {path: 'sign-up', component: SignUpComponent, canActivate: [AuthGuard]},
    // {path: 'coming-soon', component: ComingSoonComponent},
    // {path: 'services', component: ServicesComponent},
    // {path: 'service-details', component: ServicesDetailsComponent},
    // {path: 'product', component: ProductsComponent},
    {path: 'product-details/:id/:name', component: ProductsDetailsComponent},
    {path: 'failed-order/:id', component: FailedOrderComponent},
    // {path: 'blog', component: BlogComponent},
    // {path: 'blog-details', component: BlogDetailsComponent},
    // {path: 'contact', component: ContactComponent},
    {path: '**', component: ErrorComponent},
];

@NgModule({
    imports: [RouterModule.forRoot(routes, {})],
    exports: [RouterModule]
})
export class AppRoutingModule { }